import { createApp } from 'vue/dist/vue.esm-bundler.js'
{
  const appConfig = {
    data(){
      // we aren't using every input in the <form> here - only the ones we need interaction with
      // when we submit the form, we will just use JS FormData to collect all entered info
      return {
        // localized data
        members: [], 

        // state data
        loading: false,
        successMessage: "",
        currentStep: 1,
        potentialMatches: [],
        nomineeFirstName: "",
        nomineeLastName: "",
        pastWinnerInfo: {},

        // user data:
        category: "",
        nominationReason: "",
        potentialMatch: null
      }
    },
    mounted(){
      this.members = window?.availableNominationMembers || []
    },
    computed: {
      nominationReasonWordCount(){
        return this.nominationReason.match(/\s+/g)?.length || 0
      },
      filteredMembers(){
        return !this.category ? [] : this.members.filter(m => {
          const catId = parseInt(this.category)
          let valid = false
          if(catId < 1){
            // weird hack to make display categories with no real equivalent show all members
            valid = true
          } else if(m.category_ids.indexOf(catId) != -1){
            // if this is a real category, then show memebers who are part of it
            valid = true
          }
          return valid
        })
      }
    },
    methods: {
      submitNomineeInfo(){
        this.loading = true
        const formData = new FormData()
        const form = this.$refs.form1
        form.querySelectorAll('input, textarea, select').forEach(input => {
          formData.append(input.name, input.value)
        })

        formData.append('action', 'check_for_similar_nominees')

        jQuery.ajax({
          url: coolfse.ajaxUrl, // Localized variable
          method: 'POST',
          data: formData,
          processData: false,
          contentType: false,
          complete: data => {
            this.loading = false
            if(data.status == 200){
              if(data?.responseJSON?.success){
                if(data?.responseJSON?.data?.past_winner_info){
                  this.pastWinnerInfo = data.responseJSON.data.past_winner_info
                  this.currentStep = 4
                } else if(data?.responseJSON?.data?.potential_matches){
                  if(data.responseJSON.data.potential_matches.length){
                    this.potentialMatches = data.responseJSON.data.potential_matches
                    this.currentStep = 2
                  } else {
                    this.currentStep = 3
                  }
                } else {
                  alert("Something went wrong. Please try again later. Error code: 1")
                }
              } else {
                alert("Something went wrong. Please try again later. Error code: 2")
              }
            } else {
              alert("Something went wrong. Please try again later. Error code: " + data.status)
            }
          }
        })
      },
      selectExistingNominee(e){
        if(this.potentialMatch){
          this.nomineeFirstName = this.potentialMatch.first_name
          this.nomineeLastName = this.potentialMatch.last_name
          this.$refs.firstNameInput.value = this.potentialMatch.first_name
          this.$refs.lastNameInput.value = this.potentialMatch.last_name
        }
        this.currentStep = 3
      },
      submitNomineeForm(){
        /**
         * Handle errors
         */
        const fileInput = this.$refs.supportingDocument;
        const file = fileInput?.files[0];

        if(this.nominationReasonWordCount < 100){
          alert("Please ensure your \"Reason for Nomination\" has at least 100 words.")
          this.$refs.reasonForNomination.focus()
          return;
        } else if (file && file.size > 1024 * 1024){
          alert("The supporting document file size must be less than 1 MB.")
          fileInput.focus();
          return;
        }

        /**
         * Handle submission
         */

        this.loading = true

        const formData = new FormData()
        const forms = [ this.$refs.form1, this.$refs.form2 ]
        forms.forEach(form => {
          form.querySelectorAll('input, textarea, select').forEach(input => {
            if (input.type === 'file') {
              Array.from(input.files).forEach(file => {
                formData.append(input.name, file)
              })
            } else if(input.type === 'radio') {
              if(input.checked){
                formData.append(input.name, input.value)
              }
            } else {
              formData.append(input.name, input.value)
            }
          })
        })

        jQuery.ajax({
          url: coolfse.ajaxUrl, // Localized variable
          method: 'POST',
          data: formData,
          processData: false,
          contentType: false,
          complete: data => {
            this.loading = false
            if(data.status == 200){
              if(data?.responseJSON?.success && data?.responseJSON?.data?.success_message){
                this.successMessage = data?.responseJSON.data.success_message
                setTimeout(() => this.$refs.successMessage.focus(), 1)
              } else {
                alert('Something went wrong. Please try again later.')
              }
            } else {
              alert('Something went wrong. Please try again later.')
            }
          }
        })
      },
    }
  }

  function initApp(){
    const els = document.querySelectorAll('.rose-nomination-form')
    if(els.length){
      els.forEach(el => {
        const app = createApp(appConfig)
        app.mount(el)
      })
    }
  }

  initApp()
}